/**
 * @fileoverview User Management table constants.
 * @description The directory table's columns, in order, as their translation keys under
 * `sales.userManagement.columns`, and how many there are (the loading skeleton draws as many).
 * @copyright Copyright (c) 2026 Brownbox Consulting. All rights reserved.
 * @author Anshul Rokde
 */

/** The table's columns, left to right. */
export const USER_TABLE_COLUMN_KEYS = [
  'user',
  'email',
  'role',
  'department',
  'reportingTo',
  'state',
  'phone',
  'doj',
  'status',
  'actions',
] as const

/** How many columns the table has. */
export const USER_TABLE_COLUMN_COUNT = USER_TABLE_COLUMN_KEYS.length
